module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alerts":"Alerts","loadmore":"Load more","nonotifications":"No alerts."},"de":{"alerts":"Alarme","loadmore":"Weitere anzeigen","nonotifications":"Keine Alarme."},"fr":{"alerts":"Alarmes","loadmore":"Chargez plus","nonotifications":"Aucune alarmes."},"it":{"notifications":"Allarmi","loadmore":"Mostra di più","nonotifications":"Nessun allarme."}}')
  delete Component.options._Ctor
}
